export const TIME_OUT_LABEL = "CME API connection timeout";
export const NOT_FOUND_LABEL ="Not Found";
export const INTERNAL_ERROR_LABEL ="Internal Error";
export const REQUIRE_LABEL = "Required";
export const URL_LABEL = "กรุณาระบุ http:// หรือ https:// นำหน้า";
export const MAX_UPLOAD_FILE_SIZE_LABEL = "Maximum upload file 10Mbytes";
